<template>
  <div class="cont1">

    Zadejte své nové heslo

    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            v-model="password1"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show1 ? 'text' : 'password'"
            :hint="'ok'"
            name="input-10-1"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="password2"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min, rules.stejne]"
            :type="show1 ? 'text' : 'password'"
            :hint="'ok'"
            name="input-10-1"
            counter
            @click:append="show2 = !show2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
         <v-col>

           <button :class="'btn '+(formIsValid ? '':'disabled')" @click.prevent="nastavit" :disabled="!formIsValid">Nastavit heslo</button>

            <div v-if="err" class="alert">
              {{err}}
            </div>
           <div v-if="ok" class="success">
             Heslo bylo nastaveno.
           </div>

         </v-col>
      </v-row>
    </v-container>

    <p>p: {{ho}} </p>
  </div>
</template>

<script>
// @ is an alias to /src
const axios = require('axios')
export default {
  name: 'Zmena',
  components: {

  },
  mounted () {

  },
  data () {
    return {
      show1: false,
      show2: false,
      password1: '',
      password2: '',
      err:'',
      ok: false,
      ho:'',
      rules: {
        required: value => !!value || 'Povinné.',
        min: v => v.length >= 6 || 'Minimálně 6 znaků',
        stejne: p => p == this.password1 || 'Hesla se musí shodovat'
      }
    }
  },
  computed: {
      formIsValid () {
        return (
          this.password1.length>=6
          && this.password1 == this.password2
        )
      },
    },
  methods:{
    nastavit(){

      var host = 'http://localhost:3000'
      const h = window.location.toString()
      if (h.indexOf('pass.arthur.city')>=0) host = 'https://app.arthur.city'
      if (h.indexOf('pass2.arthur.city')>=0) host = 'https://app-sandbox.arthur.city'


      axios.post(host + '/api/v2/users/setpassword',
              {
                pass: this.password1,
                token: this.$route.params.token
              }
        ).then(result => {
        console.log('res', result.data)
        // eslint-disable-next-line eqeqeq

        if (result.status >= 200 && result.status<300 ) {
          this.ok = true
        }

      }).catch(err => {
        if (err.response.status>=400){
          this.err =  err.response.data.error
        }
      })

    }
  }
}
</script>


<style>

  button.disabled{
    opacity: 0.5;
  }
  .cont1{
    margin:auto;
    max-width:400px
  }

  .success{
    margin-top:1em;
    color:green;
  }
</style>
